<footer>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-8 col-md-push-4">
                <div class="col-md-6 footer-content footerColumnStyle mob-display-none">&nbsp;
                    <div class="divider-line div-line-width for-mobile"></div>
                </div>
                <div class="col-md-6 footer-content footerColumnStyle no-border-mobile" *ngFor="let item of footerText">
                    <b>{{item.title}}</b>
                    <p>{{item.desc}}</p>
                    <div class="divider-line div-line-width for-mobile"></div>
                </div>
            </div>
            <div class="col-md-4 col-md-pull-8 footerColumnStyle footer-content footer-contentLogo">
                <div *ngIf="sharedService.theme === 'dark'">
                    <img src="./assets/img/Markets01.jpg" alt="footer logo" class="footer-logo logo-spec">
                </div>
                <div *ngIf="sharedService.theme !== 'dark'">
                    <img src="assets/img/dark/logo.png" width="88" alt="footer logo" class="footer-logo logo-spec">
                </div>
                <p> CorporateD Identity Number (CIN): U65923PN2014PLC150522.</p>
                <div class="divider-line div-line-width for-mobile"></div>
            </div>
        </div>
    </div>
</footer>